import React from 'react';
import CheckeredPatternMaker from './components/CheckeredPatternMaker';

function App() {
  return (
    <div className="App">
      <CheckeredPatternMaker />
    </div>
  );
}

export default App;